import { render, staticRenderFns } from "./VoteBadge.vue?vue&type=template&id=431c43b4&"
import script from "./VoteBadge.vue?vue&type=script&lang=ts&"
export * from "./VoteBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports